import i18n from '@/i18n'

export const PasswordResetFormSchema = {
  fields: [
    {
      type: 'slot',
      model: 'password',
      label: i18n.t('wallet.form.password.label')
    },
    {
      type: 'slot',
      model: 'confirmPassword',
      label: i18n.t('wallet.form.confirm-password.label')
    }
  ]
}
